import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { triggerSyncCalendar } from '@/utils/syncCalendar';

export function SyncCalendarSubscriber() {
  useEffect(() => {
    const channel = supabase
      .channel('sync-calendar-watch')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'tasks' }, () => triggerSyncCalendar())
      .on('postgres_changes', { event: '*', schema: 'public', table: 'weekly_task_templates' }, () => triggerSyncCalendar())
      .on('postgres_changes', { event: '*', schema: 'public', table: 'weekly_task_schedule' }, () => triggerSyncCalendar())
      .subscribe();
    return () => { supabase.removeChannel(channel); };
  }, []);
  return null;
}
